/* Destilo — Newsletter Split: open a contact modal from a "reason" link,
   prefilling the reason. Reopens automatically after submit (success/error). */
(function () {
  function init() {
    const modal = document.querySelector('[data-ns-modal]');
    if (!modal) return;
    const reasonInput = modal.querySelector('[data-ns-reason-input]');

    function open(reason) {
      // Si se abre desde un motivo concreto, SIEMPRE lo rellena (aunque ya
      // hubiera otro). Al reabrir tras enviar se llama open('') → no lo pisa.
      // El motivo se guarda SIEMPRE en mayúsculas.
      if (reason && reasonInput) reasonInput.value = reason.toUpperCase();
      modal.classList.add('is-open');
      document.body.classList.add('ns-modal-open');
      const first = modal.querySelector('input, textarea');
      if (first) setTimeout(() => first.focus(), 50);
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.classList.remove('ns-modal-open');
    }

    // Apartado al que llevar al usuario (donde están los motivos de contacto).
    const section = document.querySelector('.newsletter-split');

    // Scroll suave al apartado y abre el modal SOLO cuando el scroll ha terminado
    // de verdad. Un timeout fijo no vale: la duración depende de la distancia, y si
    // abrimos antes de llegar se bloquea el scroll del body (overflow:hidden) y da
    // el "salto". Detectamos el fin real del scroll (cuando deja de moverse).
    function openWithScroll(reason) {
      if (!section) {
        open(reason);
        return;
      }

      let settle = null;
      let safety = null;
      function done() {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(settle);
        clearTimeout(safety);
        open(reason);
      }
      function onScroll() {
        // Cada frame del scroll reinicia el temporizador; cuando deja de moverse
        // ~90ms es que ya ha llegado.
        clearTimeout(settle);
        settle = setTimeout(done, 90);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      // Si ya está a la vista (no hace falta scrollear) no habrá eventos: abrimos.
      settle = setTimeout(done, 140);
      // Tope de seguridad para no quedarnos nunca esperando.
      safety = setTimeout(done, 1400);

      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    document.querySelectorAll('[data-ns-reason]').forEach((btn) => {
      btn.addEventListener('click', () => open(btn.dataset.nsReason || ''));
    });
    modal.querySelectorAll('[data-ns-modal-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    // Enlaces (p. ej. "Asistencia para pedidos" del footer) con ?ns_reason=<motivo>.
    // · Si YA estamos en la home: NO recargamos → scroll suave + abrir el form.
    // · Si estamos en otra página: dejamos que navegue a la home; allí, al cargar,
    //   se hace el scroll suave y se abre el form (bloque de abajo).
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="ns_reason="]');
      if (!link) return;
      let reason = '';
      try {
        reason = new URL(link.href, window.location.origin).searchParams.get('ns_reason') || '';
      } catch (_) {}
      const onHome = window.location.pathname === '/' || window.location.pathname === '';
      if (onHome) {
        e.preventDefault();
        openWithScroll(reason);
      }
    });

    // Keep the modal open after a submit so the success / error is visible.
    if (modal.querySelector('[data-ns-open]')) open('');

    // Al llegar a la home desde otra página con ?ns_reason=<motivo>: scroll suave
    // al apartado + abrir el form. Limpiamos la URL para que un refresco no reabra.
    const urlReason = new URLSearchParams(window.location.search).get('ns_reason');
    if (urlReason) {
      openWithScroll(urlReason);
      const params = new URLSearchParams(window.location.search);
      params.delete('ns_reason');
      const query = params.toString();
      const cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
